import api from '@/api';

export default {
    /**
     *  문서 리스트를 가져옵니다	         
     */
     getDocumentList(req: workflow.RequestDocument): Promise<any[]> {
        return api.post<string>({
            url: '/workflow/mobile/api/document/list',
            data: req,
        }).then((res) => {
            var obj = Object.create(null);
            if (res) {
                obj = res;
            }
            return obj;
        });
    },
}